import { liteClient } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { connectSearchBox } from 'instantsearch.js/es/connectors';
import { 
	index,
	configure,
	hits,
	stats
} from 'instantsearch.js/es/widgets';


const searchClient = liteClient('L6OXTKCGTN', '24872015c7c2a2b24803633ffb2f5a12');
const indexName = 'resources';

export default class SmartSearchOverlay {
	constructor() {
		

		this.search = instantsearch({
			indexName: indexName,
			// routing: true,
			searchClient,
			future: {
				preserveSharedStateOnUnmount: false
			}
		} );
	}

	showLoadingIndicator () {
		document.querySelector( '.smart-search-loading-indicator' ).style.display = 'flex'; // flex to center loading indicator
	}

	init () {
		this.submitBtn = document.querySelector( '.smart-search-submit button[type="submit"]' );

		// Create a render function
		const renderSearchBox = ( renderOptions, isFirstRender ) => {
			const { 
				query, 
				refine, 
				isSearchStalled, 
				widgetParams,
			} = renderOptions;
			const form = document.createElement('form');
			const input = document.createElement('input');
			const loadingIndicator = document.createElement('span');

			const container = document.querySelector('.smart-search-results');

			if (isFirstRender) {
				input.placeholder = widgetParams.placeholder || `Search...` ;
				loadingIndicator.textContent = 'Loading...';

				if ( widgetParams.autofocus && widgetParams.autofocus === true ) {
					input.setAttribute('autofocus', 'true');
				}

				input.addEventListener('input', event => {
					refine(event.target.value);
				});
				

				form.appendChild(input);
				form.appendChild(loadingIndicator);
				widgetParams.container.appendChild(form);
				
			}

			widgetParams.container.querySelector('input').value = query;
			widgetParams.container.querySelector('span').hidden = !isSearchStalled;

			// dont display results if query is empty or too short
			container.style.display = query.trim() === '' || query.length < 3 ? 'none' : '';

			// include `enter` key press for search query
			document.querySelector('#searchbox form').addEventListener('submit', (e) => {
				e.preventDefault();
				this.showLoadingIndicator();
				window.location.href=`${window.location.origin}/search?q=${query}&tab=google`;
			});

			if ( this.submitBtn ) {
				this.submitBtn.addEventListener('click', (e) => {
					e.preventDefault();
					this.showLoadingIndicator();
					window.location.href=`${window.location.origin}/search?q=${query}&tab=google`;
				})
			}
		};

		// create custom searchbox
		const customSearchBox = connectSearchBox( renderSearchBox );

		this.search.addWidgets([
			configure({
				hitsPerPage: 3,
			}),
			customSearchBox({
				autofocus: true,
				container: document.querySelector('#searchbox'),
				placeholder: 'Search all of ncsu.edu',
			}),
			hits({
				container: '#resource-hits',
				templates: {
					item(hit, { html, components }) {
						return html`
							<div class="resource-link">
								<a href="${ hit.url }">
									<span class="resource-title">${ hit.title }</span>
									<span class="resource-description">${ hit.description }</span>
								</a>
							</div>
						`;
					},
					empty(results, { html }) {
						return html`No results have been found.`;
					},
				},
			}),
			stats({
        container: '#resource-stats',
				templates: {
					text: `
						{{#hasManyResults}}<a href="${window.location.origin}/search?q={{query}}&tab=resources">See all {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results </a>{{/hasManyResults}}
					`
        }
			}),

			index({indexName: 'buildings'})
			.addWidgets([
				configure({
					hitsPerPage: 3,
				}),
				hits({
					container: '#building-hits',
					templates: {
						item(hit, { html, components }) {
							return html`
								<div class="building-link">
									<a href="https://maps.ncsu.edu/#/buildings/107/${ hit.buildingNumber }">
										<span class="building-name">${ hit.name }</span>
										<span class="building-address">${ hit.address } Raleigh, NC ${ hit.zip }</span>
									</a>
								</div>
							`;
						},
						empty(results, { html }) {
							return html`No results have been found.`;
						},
					}
				}),
				stats({
					container: '#building-stats',
					templates: {
						text: `
							{{#hasManyResults}}<a href="${window.location.origin}/search?q={{query}}&tab=locations">See all {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results</a>{{/hasManyResults}}
						`
					}
				}),
			]),

			index({indexName: 'people'})
			.addWidgets([
				configure({
					hitsPerPage: 3,
				}),
				hits({
					container: '#people-hits',
					templates: {
						item(hit, { html, components }) {
							let username = hit.email.split('@')[0];
							return html`
								<div class="people-link">
									<a href="https://directory.ncsu.edu/users/${ username }">
										<span class="people-name">${ hit.first_name } ${ hit.last_name }</span>
										<span class="people-title">${ hit.title }</span>
									</a>
								</div>
							`;
						},
						empty(results, { html }) {
							return html`No results have been found.`;
						},
					}
				}),
				stats({
					container: '#people-stats',
					templates: {
						text: `
							{{#hasManyResults}}<a href="${window.location.origin}/search?q={{query}}&tab=people">See all {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results</a>{{/hasManyResults}}
						`
					}
				}),
			])
			
		]);
		
		this.search.start();
	}
}
